import { StyleSheet } from 'aphrodite';
import { borderOutline, header, titles, white } from '../../../../../web/styles/colors';
import { absoluteCenterStyle } from '../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	root: {
		width: 600,
		boxSizing: 'border-box',
		padding: 8,
	},
	checkboxButtonRow: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		marginBottom: 0,
	},
	addConfigurationButton: {
		marginLeft: 'auto',
	},
	twoColumnLayout: {
		display: 'flex',
		gap: 24,
		marginTop: 20,
	},
	column: {
		flex: 1,
	},
	businessHoursCheckbox: {
		marginBottom: 16,
		marginTop: 8,
	},
	businessHoursHeader: {
		color: header,
		fontSize: 16,
		margin: 0,
		marginBottom: 8,
	},
	businessHoursManage: {},
	emailDomainHeader: {
		color: header,
		fontSize: 16,
		margin: 0,
		marginBottom: 8,
		display: 'flex',
		alignItems: 'center',
		gap: 6,
	},
	emailDomainDomain: {
		fontSize: 14,
	},
	infoIcon: {
		cursor: 'pointer',
		display: 'inline-flex',
		alignItems: 'center',
		width: 14,
		height: 14,
	},
	infoPopover: {
		maxWidth: 300,
		padding: 12,
		fontSize: 14,
		lineHeight: 1.5,
		backgroundColor: white,
		border: `1px solid ${borderOutline}`,
		borderRadius: 4,
		boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
		margin: 0,
	},
	checkboxContent: {
		marginLeft: '25px !important',
		width: 400,
	},
	container: {
		marginBottom: 20,
		maxHeight: 500,
		overflowY: 'auto',
		boxSizing: 'border-box',
		width: '100%',
	},
	footer: {
		display: 'flex',
		marginTop: 24,
		gap: 8,
	},
	infoFieldEmail: {
		marginBottom: 0,
	},
	infoFieldTall: {
		marginBottom: '0px !important',
	},
	loading: {
		...absoluteCenterStyle,
	},
	text: {
		color: titles,
		fontSize: 14,
		marginLeft: 10,
		width: 100,
	},
});
